import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import GamesList from './components/GamesList';
import ChessBoard from './components/ChessBoard';
import Login from './components/Login';
import PrivateRoute from './components/PrivateRoute';
import Profile from './pages/Profile';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/games" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/games" element={<PrivateRoute><GamesList /></PrivateRoute>} />
        <Route path="/game/:id" element={<PrivateRoute><ChessBoard /></PrivateRoute>} />
        <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
      </Routes>
    </Router>
  );
};

export default App;
